
import { defineComponent } from 'vue'
import Text from './common/Text.vue'
import { getHomeScreen } from '@/scripts/root/homeScreens'

export default defineComponent({
  components: {
    Text,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    demo(): string {
      return getHomeScreen(this.currentLanguage, 8)
    },
    formattedHeader() {
      return this.$t('home.weightManagement.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.weightManagement.desc').replace(/\n/g, '<br>')
    },
  },
})
